<template>
  <div>
    <Content title="SLA Performance Extend to SAP" />
  </div>
</template>
<script>
export default {
  components: {
    Content: () => import('@/components/dashboard/main-kpi/content.vue'),
  },
}
</script>
